$(document).ready(function () {
  // Homepage slider start
  var owl = $(".custom-slider .owl-carousel").owlCarousel({
    loop: true,
    margin: 10,
    dots: false,
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      }, 
      1000: {
        items: 1,
      },
    },
  });
  $(".customNextBtn").click(function () {
    owl.trigger("next.owl.carousel");
  });
  $(".customPreviousBtn").click(function () {
    owl.trigger("prev.owl.carousel");
  });
  // Homepage Slider End
  
  // Page Slider start
  var owl = $(".owl-carousel");
  owl.owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
    onInitialized: function (event) {
      updateExternalContent(event.item.index);
    },
  });
  function updateExternalContent(slideIndex) {
    var slideContent = $(".owl-carousel .item")
      .eq(slideIndex)
      .find(".slider_content");
    var allDescriptions = slideContent
      .find("p")
      .map(function () {
        return $(this).html(); 
      })
      .get()
      .join("<br>"); 

    var slideTitle = slideContent.find("h5").text().trim() || "Default Title"; // Default title if not found
    var slideLinkText = slideContent.find("a").text().trim() || ""; // Empty if no link
    var slideLinkHref = slideContent.find("a").attr("href") || "#"; // Default to '#' if no link

    $("#slider-title").text(slideTitle);
    $("#slider-description").html(allDescriptions);

    if (slideLinkText) {
      $("#slider-description").append(
        `<br><a href="${slideLinkHref}" target="_blank">${slideLinkText}</a>`
      );
    }
  }

  owl.on("changed.owl.carousel", function (event) {
    var currentSlideIndex = event.item.index; // Get the current slide index (0-based)
    updateExternalContent(currentSlideIndex);
  });

  $(".customPreviousBtn").click(function () {
    owl.trigger("prev.owl.carousel");
  });

  $(".customNextBtn").click(function () {
    owl.trigger("next.owl.carousel");
  });
  // Page slider End
});


// Video Script Start
const playPauseButtons = document.querySelectorAll(
  ".walkaroundheavenallday-playpause"
);
const stopButtons = document.querySelectorAll(".walkaroundheavenallday-stop");
const muteButtons = document.querySelectorAll(".walkaroundheavenallday-mute");

playPauseButtons.forEach((button) => {
  button.addEventListener("click", function () {
    const video = this.closest(
      ".walkaroundheavenallday-videoContainer"
    ).querySelector("video");

    if (video.paused) {
      video.play(); 
      this.textContent = "Pause";
      this.setAttribute("data-state", "pause");
    } else {
      video.pause();
      this.textContent = "Play";
      this.setAttribute("data-state", "play");
    }
  });
});

stopButtons.forEach((button) => {
  button.addEventListener("click", function () {
    const video = this.closest(
      ".walkaroundheavenallday-videoContainer"
    ).querySelector("video");

    video.pause();
    video.currentTime = 0;
    const playPauseButton = this.closest(".controls").querySelector(
      ".walkaroundheavenallday-playpause"
    );
    playPauseButton.textContent = "Play"; 
    playPauseButton.setAttribute("data-state", "play");  
  });
});

muteButtons.forEach((button) => {
  button.addEventListener("click", function () {
    const video = this.closest(
      ".walkaroundheavenallday-videoContainer"
    ).querySelector("video");

    if (video.muted) {
      video.muted = false; 
      this.textContent = "Mute"; 
      this.setAttribute("data-state", "mute"); 
    } else {
      video.muted = true; 
      this.textContent = "Unmute";
      this.setAttribute("data-state", "unmute");
    }
  });
});
// Video script End

// audio script start
document.addEventListener("DOMContentLoaded", function () {
  const videoDivs = document.querySelectorAll(".video");

  videoDivs.forEach(function (videoDiv) {
    const audio = videoDiv.querySelector(".wurlitzer-video");
    const playPauseButton = videoDiv.querySelector(".wurlitzer-playpause");
    const stopButton = videoDiv.querySelector(".wurlitzer-stop");
    const muteButton = videoDiv.querySelector(".wurlitzer-mute");

    playPauseButton.addEventListener("click", function () {
      if (audio.paused) {
        audio.play(); 
        playPauseButton.textContent = "Pause";
        playPauseButton.setAttribute("data-state", "pause");
      } else {
        audio.pause(); 
        playPauseButton.textContent = "Play"; 
        playPauseButton.setAttribute("data-state", "play");
      }
    });

    stopButton.addEventListener("click", function () {
      audio.pause();
      audio.currentTime = 0;
      playPauseButton.textContent = "Play";
      playPauseButton.setAttribute("data-state", "play");
    });

    muteButton.addEventListener("click", function () {
      if (audio.muted) {
        audio.muted = false;
        muteButton.textContent = "Mute";
        muteButton.setAttribute("data-state", "mute");
      } else {
        audio.muted = true; 
        muteButton.textContent = "Unmute";
        muteButton.setAttribute("data-state", "unmute");
      }
    });
  });
});

// audio script end


// First menu open but in other page first menu close

// document.addEventListener("DOMContentLoaded", function () {
//   const currentUrl = window.location.href;
// console.log(currentUrl);

//   requestAnimationFrame(() => {
//     setTimeout(function () {
//       const allDetails = document.querySelectorAll('.header__inline-menu details');
//       let openTarget = null;

//       // Step 1: Find the active span
//       const activeSpan = document.querySelector('.header__active-menu-item');

//       if (activeSpan) {
//         const parentDetails = activeSpan.closest('details');

//         if (parentDetails) {
//           openTarget = parentDetails;
//         }
//       } else {
//         // Step 2: No active span? Default to Details-HeaderMenu-1
//         //openTarget = document.getElementById('Details-HeaderMenu-1');
//       }

//       // Step 3: Close all details
//       allDetails.forEach(details => {
//         details.removeAttribute('open');
//       });

//       // Step 4: Open only the selected one
//       const baseUrl = window.location.origin;
//       const currentUrl = window.location.href;

//       console.log(openTarget);
//       if (openTarget) {
//         openTarget.setAttribute('open', '');
//       } else if( currentUrl == baseUrl+'/') {
//         openTarget = document.getElementById('Details-HeaderMenu-1');
//         openTarget.setAttribute('open', '');
//       }
//     }, 0);
//   });
// });


// Default first menu oepn

// document.addEventListener("DOMContentLoaded", function () {
//   const worksMenu = document.getElementById('Details-HeaderMenu-1');
//   if (!worksMenu) return;

//   worksMenu.setAttribute('open', '');

//   worksMenu.addEventListener('toggle', function () {
//     if (!worksMenu.hasAttribute('open')) {
//       worksMenu.setAttribute('open', '');
//     }
//   });
// });



// document.addEventListener('DOMContentLoaded', function() {
//     const submenu = document.querySelector('#Details-HeaderSubMenu-1-0');  // Third-level submenu
//     const links = submenu.querySelectorAll('a');  // All links inside the third-level submenu

//     // Define the third-level pages that should keep the submenu open
//     const thirdLevelPages = [
//         '/pages/2026',
//         '/pages/2025',
//         '/pages/2024',
//         '/pages/2023',
//         '/pages/2022',
//         '/pages/2021',
//         '/pages/2020',
//         '/pages/2016-2020'
//     ];

//     // Check if the current page is one of the third-level submenu pages
//     const isInThirdCategory = thirdLevelPages.some(page => window.location.pathname.includes(page));

//     // If the user is on any third-level page, open the submenu
//     if (isInThirdCategory) {
//         submenu.setAttribute('open', '');  // Make sure the submenu stays open
//     }

//     // Add an event listener for each link inside the third-level submenu
//     links.forEach(link => {
//         link.addEventListener('click', function() {
//             submenu.setAttribute('open', '');  // Keep the submenu open after clicking a link
//         });
//     });

//     // Handle the case where the user might manually close the submenu
//     submenu.addEventListener('toggle', function() {
//         if (!submenu.open) {
//             // If the submenu is closed manually, re-open it if we're in the third-level category
//             if (isInThirdCategory) {
//                 submenu.setAttribute('open', '');
//             }
//         }
//     });
// });





setTimeout(function() {
  (function () {
    const currentPath = window.location.pathname;

    // solo urls
    const soloUrls = [
      '/pages/mommas-baby-daddys-maybe',
      '/pages/halfrican',
      '/pages/the-bathers',
      '/pages/melanoidin',
      '/pages/the-close-of-day',
      '/pages/frieze-la',
      '/pages/medea',
      '/pages/clouds-in-my-coffee',
      '/pages/aleczander',
      '/pages/half-note',
      '/pages/troubled-waters',
      '/pages/you-can-lead-a-horse-to-water',
      '/pages/glory-glory'
    ];

    // group urls
    const groupUrls = [
      '/pages/resonance',
      '/pages/norton-museum-of-art',
      '/pages/dallas-museum-of-art',
      '/pages/steven-paneccasio',
      '/pages/get-in-the-game',
      '/pages/jeanette-may',
      '/pages/black-california-dreamin',
      '/pages/craig-robins-collection',
      '/pages/ngv-triennial',
      '/pages/green-family-art-foundation',
      '/pages/rubell-museum',
      '/pages/artsts-on-boxing',
      '/pages/the-artist-and-pace-prints',
      '/pages/fire-figure-fantasy',
      '/pages/real-corporeal',
      '/pages/the-drawing-centre-show',
      '/pages/anita-posada',
      '/pages/photographer-credit-ian-ace',
      '/pages/matter-form',
      '/pages/20',
      '/pages/photography-by-jenna-bascom',
      '/pages/a-lovers-discourse',
      '/pages/hammer-museum',
      '/pages/life-still',
      '/pages/art-usa-today',
      '/pages/next-of-kin',
      '/pages/art-on-the-grid',
      '/pages/the-artist-and-pace-prints',
      '/pages/black-american-portraits'

    ];

    // project detail urls
    const projectUrls = [
      '/pages/burton-details',
      '/pages/sunnyday-details'
      // aur add karte ja
    ];

    let activeTab = null;
    if (soloUrls.includes(currentPath)) {
      activeTab = 'solo';
    } else if (groupUrls.includes(currentPath)) {
      activeTab = 'group';
    } else if (projectUrls.includes(currentPath)) {
      activeTab = 'projects';
    }

    if (activeTab) {
      let link = null;

      if (activeTab === 'solo') {
        link = document.querySelector(`.header__submenu a[href="/pages/solo"]`);
      } else if (activeTab === 'group') {
        link = document.querySelector(`.header__submenu a[href="/pages/group"]`);
      } else if (activeTab === 'projects') {
        // Projects top-level link
        link = document.querySelector(`.header__inline-menu a[href="/pages/projects"]`);
      }

      if (link) {
        link.classList.add('list-menu__item--active');
        link.setAttribute('aria-current', 'page');

        const details = link.closest('details');
        if (details) {
          details.setAttribute('open', 'true');
          const summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }

        console.log(`✅ Marked "${activeTab.toUpperCase()}" menu as active for ${currentPath}`);
      } else {
        console.warn(`⚠️ Could not find header link for: ${activeTab}`);
      }
    } else {
      console.warn(`❌ Current page ${currentPath} not found in solo, group or projects URLs`);
    }
  })();
}, 1000);



// Image Features blur Features

// (function () {
//   const config = {
//     rootMargin: "150px",
//     blurClass: "img-blur",
//     revealClass: "img-reveal",
//     placeholderQuality: 30,
//     selector: "img[data-lazy-blur]",
//     excludeSelector: `
//       .homepage-custom-slider .custom_img,
//       .custom_press .rte img
//     `
//   };

//   /* ---------------- CSS ---------------- */
//   const style = document.createElement("style");
//   style.innerHTML = `
//     img[data-lazy-blur] {
//       display: block;
//       transition: filter 0.9s ease, transform 0.9s ease;
//       will-change: filter, transform;
//       backface-visibility: hidden;
//     }

//     .${config.blurClass} {
//       filter: blur(10px);
//       transform: scale(1.03);
//     }

//     .${config.revealClass} {
//       filter: blur(0);
//       transform: scale(1);
//     }
//   `;
//   document.head.appendChild(style);

//   /* -------- Helpers -------- */
//   function isExcluded(img) {
//     return img.matches(config.excludeSelector);
//   }

//   function getLowQualitySrc(src) {
//     if (!src) return src;

//     if (src.includes("cdn.shopify.com")) {
//       return src + (src.includes("?") ? "&" : "?") + "width=" + config.placeholderQuality;
//     }

//     return src;
//   }

//   /* -------- Prepare images -------- */
//   function prepareImages() {
//     const images = document.querySelectorAll("img:not(.header__heading-logo)");

//     images.forEach(img => {
//       if (img.dataset.ready) return;
//       if (isExcluded(img)) return;

//       const originalSrc = img.getAttribute("src");
//       if (!originalSrc) return;

//       img.dataset.originalSrc = originalSrc;

//       img.src = getLowQualitySrc(originalSrc);
//       img.classList.add(config.blurClass);

//       img.dataset.ready = "true";
//       img.setAttribute("data-lazy-blur", "true");
//     });
//   }

//   /* -------- Load image -------- */
//   function loadImage(img) {
//     const src = img.dataset.originalSrc;
//     if (!src) return;

//     const temp = new Image();

//     temp.onload = function () {
//       img.classList.add(config.blurClass);
//       img.classList.remove(config.revealClass);

//       requestAnimationFrame(() => {
//         requestAnimationFrame(() => {
//           img.src = src;

//           img.classList.remove(config.blurClass);
//           img.classList.add(config.revealClass);

//           setTimeout(() => {
//             img.classList.remove(config.revealClass);
//           }, 900);
//         });
//       });
//     };

//     temp.src = src;
//   }

//   /* -------- Observer -------- */
//   function initObserver() {
//     const observer = new IntersectionObserver((entries) => {
//       entries.forEach(entry => {
//         const img = entry.target;

//         if (isExcluded(img)) return;

//         if (entry.isIntersecting) {
//           loadImage(img);
//         } else {
//           img.classList.add(config.blurClass);
//           img.classList.remove(config.revealClass);
//         }
//       });
//     }, {
//       rootMargin: config.rootMargin,
//       threshold: 0.2
//     });

//     document.querySelectorAll(config.selector).forEach(img => {
//       if (!isExcluded(img)) {
//         observer.observe(img);
//       }
//     });
//   }

//   /* -------- Init -------- */
//   document.addEventListener("DOMContentLoaded", function () {
//     prepareImages();
//     initObserver();
//   });

// })();

(function () {
  const config = {
    rootMargin: "150px",
    blurClass: "img-blur",
    revealClass: "img-reveal",
    placeholderQuality: 30,
    targetClass: "lazy-blur-img"
  };

  /* ---------------- CSS (SCOPED) ---------------- */
  const style = document.createElement("style");
  style.innerHTML = `
    img.${config.targetClass} {
      display: block;
      transition: filter 0.9s ease, transform 0.9s ease;
      will-change: filter, transform;
      backface-visibility: hidden;
    }

    img.${config.targetClass}.${config.blurClass} {
      filter: blur(10px);
      transform: scale(1.03);
    }

    img.${config.targetClass}.${config.revealClass} {
      filter: blur(0);
      transform: scale(1);
    }
  `;
  document.head.appendChild(style);

  /* ---------------- HELPERS ---------------- */
  function getLowQualitySrc(src) {
    if (!src) return src;

    if (src.includes("cdn.shopify.com")) {
      return src + (src.includes("?") ? "&" : "?") +
        "width=" + config.placeholderQuality;
    }

    return src;
  }

  /* ---------------- PREPARE IMAGES ---------------- */
  function prepareImages() {
    const images = document.querySelectorAll(`img.${config.targetClass}`);

    images.forEach(img => {
      if (img.dataset.ready) return;

      const originalSrc = img.getAttribute("src");
      if (!originalSrc) return;

      img.dataset.originalSrc = originalSrc;

      // set low quality placeholder
      img.src = getLowQualitySrc(originalSrc);

      // initial blur
      img.classList.add(config.blurClass);

      img.dataset.ready = "true";
    });
  }

  /* ---------------- LOAD HIGH QUALITY IMAGE ---------------- */
  function loadImage(img) {
    const src = img.dataset.originalSrc;
    if (!src) return;

    const temp = new Image();

    temp.onload = function () {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          img.src = src;

          img.classList.remove(config.blurClass);
          img.classList.add(config.revealClass);

          setTimeout(() => {
            img.classList.remove(config.revealClass);
          }, 900);
        });
      });
    };

    temp.src = src;
  }

  /* ---------------- OBSERVER (WITH SCROLL OUT BLUR RESET) ---------------- */
  function initObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const img = entry.target;

        if (entry.isIntersecting) {
          loadImage(img);
        } else {
          // scroll out → reapply blur
          img.classList.add(config.blurClass);
          img.classList.remove(config.revealClass);
        }
      });
    }, {
      rootMargin: config.rootMargin,
      threshold: 0.2
    });

    document.querySelectorAll(`img.${config.targetClass}`).forEach(img => {
      observer.observe(img);
    });
  }

  /* ---------------- INIT ---------------- */
  document.addEventListener("DOMContentLoaded", function () {
    prepareImages();
    initObserver();
  });

})();



/*
|--------------------------------------------------------------------------
| Hide/Show Video Section Based on Grid Slider View
|--------------------------------------------------------------------------
| When the `.custom-section` switches to slider view and receives the
| `slider-view` class, the `.video-section-main` section is hidden.
| When the slider view is removed (grid view is active), the video
| section becomes visible again.
|--------------------------------------------------------------------------
*/

document.addEventListener('DOMContentLoaded', function () {

  function toggleVideoSection() {
    const customSection = document.querySelector('.custom-section');
    const videoSection = document.querySelector('.video-section-main');

    if (!customSection || !videoSection) return;

    if (customSection.classList.contains('slider-view')) {
      videoSection.style.display = 'none';
    } else {
      videoSection.style.display = '';
    }
  }

  // Initial check
  toggleVideoSection();

  // Class changes observe karo
  const customSection = document.querySelector('.custom-section');

  if (customSection) {
    const observer = new MutationObserver(toggleVideoSection);

    observer.observe(customSection, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

});